"use client";

import { Box, Typography } from "@mui/material";
import { HeroBanner } from "@/components/hero_banner";

export function HeroBannerSection() {
    return (
        <Box sx={{ height: { xs: '280px', md: '480px' } }}>
            <HeroBanner
                background="/images/reviews/bg_hero_banner.png"
                height="100%"
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            fontSize: { xs: 32, md: 48 },
                            fontWeight: 600,
                            color: "#FFFFFF",
                            textAlign: "center",
                            fontFamily: "var(--font-noto)",
                        }}
                    >
                        รีวิวของเรา
                    </Typography>
                </Box>
            </HeroBanner>
        </Box>
    );
}